'use strict';

var DependentDateValidatorDirective = function DependentDateValidatorDirective(momentService) {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      var minValueName = attrs.minDate;
      var maxValueName = attrs.maxDate;
      var minValue = null;
      var maxValue = null;
      if (minValueName !== '' && minValueName !== undefined) {
        scope.$watch(minValueName, function (newValue) {
          minValue = newValue;
          if (ctrl.$invalid) {
            ctrl.$validate();
          }
        });
      }
      if (maxValueName !== '' && maxValueName !== undefined) {
        scope.$watch(maxValueName, function (newValue) {
          maxValue = newValue;
          if (ctrl.$invalid) {
            ctrl.$validate();
          }
        });
      }
      ctrl.$validators.dependentDate = function (modelValue, viewValue) {
        if (!momentService.isMoment(viewValue)) {
          return true;
        } else {
          if (attrs.maxDate) {
            return viewValue.isBefore(maxValue) || viewValue.isSame(maxValue) || !maxValue;
          } else if (attrs.minDate) {
            return viewValue.isAfter(minValue) || viewValue.isSame(minValue) || !minValue;
          } else {
            return true;
          }
        }
      };
    }
  };
};
DependentDateValidatorDirective.$inject = ['MomentService'];
module.exports = DependentDateValidatorDirective;